import { AnimationController, Animation } from '@ionic/angular';

export const fadeAnimation = (baseEl: any, opts?: any, speed = 200): Animation => {
    const animationCtrl = new AnimationController();
  
    const enteringAnimation = animationCtrl.create()
      .addElement(opts.enteringEl)
      .duration(speed)
      .fromTo('opacity', 0, 1);
  
    const leavingAnimation = animationCtrl.create()
      .addElement(opts.leavingEl)
      .duration(speed)
      .fromTo('opacity', 1, 0);
  
    return animationCtrl.create()
      .addAnimation([enteringAnimation, leavingAnimation]);
  };
  
  export const slideAnimation = (baseEl: any, opts?: any, speed = 200): Animation => {
    const animationCtrl = new AnimationController();
  
    const enteringAnimation = animationCtrl.create()
      .addElement(opts.enteringEl)
      .duration(speed)
      .fromTo('opacity', 0, 1)
      .fromTo('transform', 'translateX(100%)', 'translateX(0)');
  
    const leavingAnimation = animationCtrl.create()
      .addElement(opts.leavingEl)
      .duration(speed)
      .fromTo('transform', 'translateX(0)', 'translateX(-100%)');
  
    return animationCtrl.create()
      .addAnimation([enteringAnimation, leavingAnimation]);
  };

  export const slideInvertedAnimation = (baseEl: any, opts?: any, speed = 200): Animation => {
    const animationCtrl = new AnimationController();
  
    const enteringAnimation = animationCtrl.create()
      .addElement(opts.leavingEl)
      .duration(speed)
      .fromTo('transform', 'translateX(0)', 'translateX(100%)');
  
    const leavingAnimation = animationCtrl.create()
      .addElement(opts.enteringEl)
      .duration(speed)
      .fromTo('opacity', 0, 1)
      .fromTo('transform', 'translateX(-100%)', 'translateX(0)');
  
    return animationCtrl.create()
      .addAnimation([enteringAnimation, leavingAnimation]);
  };

  export const noAnimation = (baseEl: any, opts?: any): Animation => {
    const animationCtrl = new AnimationController();
  
    const enteringAnimation = animationCtrl.create()
      .addElement(opts.enteringEl)
      .duration(0)
      .fromTo('transform', 'translateX(100%)', 'translateX(0)');
  
    const leavingAnimation = animationCtrl.create()
      .addElement(opts.leavingEl)
      .duration(0)
      .fromTo('transform', 'translateX(0)', 'translateX(-100%)');
  
    return animationCtrl.create()
      .addAnimation([enteringAnimation, leavingAnimation]);
  };